




























import {Component, Vue} from 'vue-property-decorator'
import { Action } from 'vuex-class'
import ChangeTemporaryPasswordRequest from '@/model/request/ChangeTemporaryPasswordRequest'

@Component
export default class ChangeTemporaryPasswordView extends Vue {
  @Action('auth/changeTemporaryPassword') changeTemporaryPassword!: Function

  request = new ChangeTemporaryPasswordRequest()

  created() {
    this.request.user = this.$route.params.user
    this.request.oldPassword = this.$route.params.oldPassword
  }
}
